/**
 * 模型展示别名（本仓覆盖）：
 * helper 已将 Flux 展示为 A2 / HOLO - A2；产品要求在名称后拼接「（原V1）」。
 * 不改 @xmiles/holopix-helper，统一由此出口给 UI 消费。
 */
import {
  getModelAlias as helperGetModelAlias,
  getModelCornerCkpt as helperGetModelCornerCkpt,
} from '@xmiles/holopix-helper';

const FORMER_V1_SUFFIX = '（原V1）';

function isFluxCkpt(value?: string | null): boolean {
  if (!value) return false;
  return value === 'Flux' || value.split(',').includes('Flux');
}

function withFormerV1Suffix(ckptType: string, label: string): string {
  if (!label || !isFluxCkpt(ckptType)) return label;
  if (label.endsWith(FORMER_V1_SUFFIX)) return label;
  return `${label}${FORMER_V1_SUFFIX}`;
}

/** 完整展示名，如 HOLO - A2（原V1） */
export function getModelAlias(value: string): string {
  return withFormerV1Suffix(value, helperGetModelAlias(value));
}

/** 角标短名，如 A2（原V1） */
export function getModelCornerCkpt(value: string): string {
  return withFormerV1Suffix(value, helperGetModelCornerCkpt(value));
}
